module.exports = __webpack_public_path__ + "static/media/AramarkMember.419b3010.png";